import axios from "axios"
import store from "@/store/store.js"
import router from "@/router/router.js"
import { app, appBuild, appVer } from "./version.js";
// 导入 element-ui的 Message
import { Message, Loading } from "element-ui";
import { removeLocalStorage, removeSessionStorage } from "@/utils/myStorage.js";
store.state.baseURL = process.env.VUE_APP_API_BASEURL
const instance = axios.create({
    baseURL: store.state.baseURL,
    timeout: 120000
})
let loading, timeout, tokenNo = 0
// 请求拦截器
instance.interceptors.request.use(function (config) {
    // 遮罩显示loading加载页面
    loading = Loading.service({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    });
    config.headers['access-token'] = store.state.userInfo.accessToken;
    config.headers['app'] = app;
    config.headers['app-build'] = appBuild;
    config.headers['app-ver'] = appVer;
    for (const key in config.data) {
        if (typeof (config.data[key]) == "string") {
            config.data[key] = config.data[key].trim() || undefined;
            // config.data[key] = config.data[key] || undefined;
        }
    }
    return config;
}, function (error) {
    // 请求错误执行
    return Promise.reject(error);
});

// 相应拦截器
instance.interceptors.response.use(function (response) {
    // 响应正确执行
    // 响应状态码：-10005，登录信息失效
    if (response.data.code == -10005) {
        tokenNo++;
        if (tokenNo == 1) {
            removeLocalStorage('userInfo')
            removeSessionStorage('userInfo')
            store.state.userInfo = {}
            router.push("/login");
            Message({
                message: response.data.msg,
                type: "error"
            });
            setTimeout(() => {
                tokenNo = 0
            },200)
        }
    } else if(response.data.code == 1024) {
        tokenNo = 0;
    } else {
        tokenNo = 0
        if (response.data.code && response.data.code != 0) {
            Message({
                message: response.data.msg,
                type: 'error'
            })
        }
    }
    // 关闭遮罩页
    loading.close();
    // 清除定时器
    clearTimeout(timeout)
    return Promise.resolve(response.data);

}, function (error) {
    // 响应错误执行
    tokenNo++;
    if (tokenNo == 1) {
        timeout = setTimeout(() => {
            // 关闭遮罩页
            loading.close();
            Message({
                message: '网络错误，请检查网络连接',
                type: "error"
            });
            tokenNo = 0;
        }, 5000);
    }
    return Promise.reject(error);
});

export default instance